var _Glyphicon;
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { ModalTrigger, Text, Glyphicon } from 'reaxl';
import FilterLocationModal from '../FilterLocationModal';

/**
 *  CTA to open/close FilterLocationModal
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilterLocationModalTrigger(_ref) {
  let {
    show = false,
    onHide = () => {},
    onSubmit = () => {},
    onOptionChange = () => {},
    filter = {},
    filters = {},
    errors = {},
    values = {},
    fallbackTriggerText,
    triggerClassName,
    textClassName,
    className,
    searchRadiusValue,
    zipValue,
    ...rest
  } = _ref;
  const zip = values?.zip || fallbackTriggerText || '';
  const ariaLabel = values?.zip ? `Currently searching near ${zip}. Change ZIP Code.` : 'Set your ZIP Code to find vehicles near you.';
  return /*#__PURE__*/_jsx(ModalTrigger, {
    showModal: show,
    modal: /*#__PURE__*/_jsx(FilterLocationModal, {
      onHide: onHide,
      filter: filter,
      filters: filters,
      errors: errors,
      values: values,
      onSubmit: onSubmit,
      onOptionChange: onOptionChange,
      searchRadiusValue: searchRadiusValue,
      zipValue: zipValue,
      ...rest
    }, "modalTriggerModal"),
    className: triggerClassName,
    "aria-label": ariaLabel,
    children: /*#__PURE__*/_jsxs(Text, {
      componentClass: "span",
      className: className,
      weight: "bold",
      size: 300,
      children: [_Glyphicon || (_Glyphicon = /*#__PURE__*/_jsx(Glyphicon, {
        glyph: "map-marker"
      })), /*#__PURE__*/_jsx("span", {
        className: clsx('padding-left-1', textClassName),
        children: zip
      })]
    }, "modalTriggerText")
  });
}
export default FilterLocationModalTrigger;